// extracted by mini-css-extract-plugin
export default {"showMoreLessToggle":"showMoreLessToggle___Pzzv3"};